import React, { useEffect } from 'react';
import { Header } from './Header';
import { HeroSection } from './HeroSection';
import { DataDreamerDefinition } from './DataDreamerDefinition';
import { ResourcesSection } from './ResourcesSection';
import { EventsSection } from './EventsSection';
import { Footer } from './Footer';
import { ImmersiveBackground } from './ImmersiveBackground';
import { ThemeToggle } from './ThemeToggle';
import { CloudCursor } from './CloudCursor';
import SEO from './SEO';

export const LandingPage = () => {
  
  // Respect user's reduced motion preference
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mediaQuery.matches) {
      document.documentElement.style.setProperty('--animation-duration', '0.01ms');
    }
  }, []);

  return (
    <div className="min-h-screen relative md:cursor-none">
      <SEO 
        title="📍somewhere data dreaming"
        description="Where data meets creativity. AI workshops, events, and community."
        image="https://customer-assets.emergentagent.com/job_caf6c523-32ed-44de-aaab-8552e94ae126/artifacts/d7ltuzdn_datadreaminglogowhite.png"
        url="/"
      />
      {/* Skip to main content link for keyboard users */}
      <a 
        href="#resources" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-black focus:text-white focus:rounded-lg focus:outline-none focus:ring-2 focus:ring-white"
      >
        Skip to main content
      </a>
      
      {/* Cloud Cursor */}
      <CloudCursor />
      
      {/* Immersive Background */}
      <ImmersiveBackground />
      
      {/* Theme Toggle */}
      <ThemeToggle />
      
      {/* Fixed header */}
      <Header />
      
      {/* Main content */}
      <main id="main-content">
        {/* Hero */}
        <HeroSection />
        
        {/* Data Dreamer Definition */}
        <DataDreamerDefinition />
        
        {/* Resources */}
        <ResourcesSection />
        
        {/* Events */}
        <EventsSection />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
